import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { GroupingLogicForm } from '@r1-compass-library/components';
import { SelectionCriterionForm } from '@r1-compass-library/models/criteria/selection-criteria-form.model';
import { PlayCriteria } from '@r1-compass-library/models/play/play-criteria.model';

export class PlayBuilderForm {
    templateCriteriaId = new FormControl<number | undefined>(undefined, {
        validators: Validators.required,
        nonNullable: true,
    });
    overrideStandardQuery = new FormControl<string | undefined>(undefined, {
        nonNullable: true,
    });
    overrideMultipleRecommendationsQuery = new FormControl<string | undefined>(undefined, {
        nonNullable: true,
    });
    groupingLogic = new FormGroup<GroupingLogicForm>(new GroupingLogicForm());
    selectionCriteria = new FormArray<FormGroup<SelectionCriterionForm>>([]);

    constructor(templateCriteriaId?: number, playCriteria?: PlayCriteria) {
        this.templateCriteriaId.setValue(templateCriteriaId);
        this.overrideStandardQuery.setValue(playCriteria?.overrideStandardQuery);
        this.overrideMultipleRecommendationsQuery.setValue(playCriteria?.overrideMultipleRecommendationsQuery);
        this.groupingLogic.patchValue(new FormGroup(new GroupingLogicForm(playCriteria?.groupingLogic)).getRawValue());
        playCriteria?.selectionCriteria.forEach(criterion => {
            this.selectionCriteria.push(new FormGroup(new SelectionCriterionForm(criterion.type, criterion)));
        });
    }
}
